const absoluteUrlRegex = /^(?:[a-z]+:)?\/\/|^mailto:/i;

/**
 * Tests if a URL is absolute
 */
export const isAbsoluteUrl = (url?: string) => {
  if (!url) return false;
  return absoluteUrlRegex.test(url);
};
